'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const ex=require('pulsar-utils/dist-es6/ex');
const{HandleUncaughtErrors}=require('../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const PromiseQueue=require('promise-queue');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');
const StickySettings=require('../../../dist-es6/shared/domain/stickySettings');
const UncaughtErrorHandler=require('../../../dist-es6/client/services/uncaughtErrorHandler');let

DisplaySettingsService=class DisplaySettingsService extends BaseService{
constructor(socketService,uncaughtErrorHandler){
super();
this._socketService=socketService;
this._uncaughtErrorHandler=uncaughtErrorHandler;

const maxConcurrency=1;
const maxQueueLength=Infinity;
this._oneByOneQueue=new PromiseQueue(maxConcurrency,maxQueueLength);

this.reset();
}

reset(){
this._persistedSettings=

null;

this._stickySettings=

null;

this._renderCache={
columnWidthForTimelineScheduleGraph:null};

}

get renderCache(){
return this._renderCache;
}

incorporateLatestSettingsFromBackend(settings){




this._persistedSettings=settings;


this._stickySettings=ex(this._stickySettings).otherwise(this._wrapStickySettings(StickySettings.fromBackend(this._persistedSettings.stickySettings)));
}

_wrapStickySettings(stickySettings){
return new StickySettingsWrapper(stickySettings,this._socketService,this._uncaughtErrorHandler,this._oneByOneQueue);
}

get isLoaded(){
return _.exists(this._persistedSettings);
}

get use24HourTimeline(){
return _.get(this._persistedSettings,'use24HourTimeline',!1);
}

get stickySettings(){
return this._stickySettings;
}

get groupVisibilitySettings(){
return _.get(this._persistedSettings,'groupVisibilitySettings');
}

toggleSidebarVisibility(){
this.stickySettings.set('groupsSidebarVisible',!this.stickySettings.get('groupsSidebarVisible'));
}

setMultiViewSelection(stickyId,selectionIndex){
this.stickySettings.set(`${stickyId}TabSelection`,selectionIndex);
}

getMultiViewSelectionFor(stickyId){
return this.stickySettings.get(`${stickyId}TabSelection`);
}};let


StickySettingsWrapper=(_class=class StickySettingsWrapper{
constructor(stickySettings,socketService,uncaughtErrorHandler,oneByOneQueue){
_.ensureInstanceOf(StickySettings,stickySettings);
_.ensureInterface(['sendAndWaitForResponse'],socketService);
_.ensureInstanceOf(UncaughtErrorHandler,uncaughtErrorHandler);
_.ensureInstanceOf(PromiseQueue,oneByOneQueue);

uncaughtErrorHandler.applyTo(this);

this._stickySettings=stickySettings;
this._socketService=socketService;
this._oneByOneQueue=oneByOneQueue;
}

get(setting){
return this._stickySettings[setting];
}

set(setting,value){
if(_.isEqual(this._stickySettings[setting],value)){
return;
}

const oldVal=this._stickySettings[setting];

this._stickySettings[setting]=value;





if(this._stickySettings[setting]===oldVal){



return;
}





return this._fireAndForgetStickySettingUpdate(setting,value);
}


async _fireAndForgetStickySettingUpdate(setting,value){
await this._oneByOneQueue.add(async()=>{
const response=await this._socketService.sendAndWaitForResponse('SetStickySettings',{[setting]:StickySettings.serialize(setting,value)});
if(!SocketResponse.succeeded(response)){
throw new Error(`SetStickySettings failed: ${response.status}`);
}
});
}},(_applyDecoratedDescriptor(_class.prototype,'_fireAndForgetStickySettingUpdate',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_fireAndForgetStickySettingUpdate'),_class.prototype)),_class);


module.exports=DisplaySettingsService;
//# sourceMappingURL=displaySettingsService.js.map
